/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-group-details.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloGroupDetailsTemplate from './silo-group-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloGroupDetails', [])
    .directive('agSiloGroupDetails', SiloGroupDetails)
    .name;

/*@ngInject*/
function SiloGroupDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            telemetryType: '<'
        },
        controller: SiloGroupDetailsController,
        controllerAs: 'vm',
        templateUrl: siloGroupDetailsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloGroupDetailsController($scope, $filter, $q, $translate, unitService, types, agTypes, agUtils, siloGroupService, entityService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.resolveIcon = resolveIcon;
    vm.loading = false;

    vm.siloGroupTelemetryHistoryLegendConfig = {
        displayMaxThreshold: true
    };

    vm.siloGroupDeltaTelemetryHistoryLegendConfig = {
        displayMaxThreshold: true
    };

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloGroupId = null;
    vm.siloGroup = null;
    vm.siloGroupData = null;

    if (vm.telemetryType === agTypes.telemetry.type.temperature) {
        vm.tempHistoryUnits = unitService.temperatureUnitSymbol();
        vm.siloGroupTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-temperature-threshold');
        vm.siloGroupDeltaTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-delta-temperature-threshold');
        vm.telemetryKeys = [agTypes.telemetry.siloGroup.currentMinTemperature, agTypes.telemetry.siloGroup.currentAvgTemperature, agTypes.telemetry.siloGroup.currentMaxTemperature];
        vm.telemetryDeltaKeys = [agTypes.telemetry.siloGroup.currentMinDeltaTemperature, agTypes.telemetry.siloGroup.currentAvgDeltaTemperature, agTypes.telemetry.siloGroup.currentMaxDeltaTemperature];
        vm.telemetryLabel = $translate.instant('ag.temperature.temperature');
        vm.deltaTelemetryLabel = $translate.instant('ag.temperature.delta-temperature');
        vm.tabTelemetryLabel = $translate.instant('ag.silo.current-temperatures');
        vm.tabDeltaTelemetryLabel = $translate.instant('ag.silo.delta-temperatures');
        vm.helpPageAction = agUtils.createHelpActionConfig("agSiloGroup");
    } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
        vm.tempHistoryUnits = unitService.moistureUnitSymbol();
        vm.siloGroupTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-moisture-threshold');
        vm.siloGroupDeltaTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-delta-moisture-threshold');
        vm.telemetryKeys = [agTypes.telemetry.siloGroup.currentMinMoisture, agTypes.telemetry.siloGroup.currentAvgMoisture, agTypes.telemetry.siloGroup.currentMaxMoisture];
        vm.telemetryDeltaKeys = [agTypes.telemetry.siloGroup.currentMinDeltaMoisture, agTypes.telemetry.siloGroup.currentAvgDeltaMoisture, agTypes.telemetry.siloGroup.currentMaxDeltaMoisture];
        vm.telemetryLabel = $translate.instant('ag.moisture.moisture');
        vm.deltaTelemetryLabel = $translate.instant('ag.moisture.delta-moisture');
        vm.tabTelemetryLabel = $translate.instant('ag.moisture.moisture');
        vm.tabDeltaTelemetryLabel = $translate.instant('ag.moisture.delta-moisture');
        vm.helpPageAction = agUtils.createHelpActionConfig("agSiloGroup", "ag.docsPageSections.silo-group-moisture-details");
    } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
        vm.tempHistoryUnits = unitService.co2UnitSymbol();
        vm.siloGroupTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-co2-threshold');
        vm.siloGroupDeltaTelemetryHistoryLegendConfig.maxThresholdLabel = $translate.instant('ag.silo.max-delta-co2-threshold');
        vm.telemetryKeys = [agTypes.telemetry.siloGroup.currentMinCO2, agTypes.telemetry.siloGroup.currentAvgCO2, agTypes.telemetry.siloGroup.currentMaxCO2];
        vm.telemetryDeltaKeys = [agTypes.telemetry.siloGroup.currentMinDeltaCO2, agTypes.telemetry.siloGroup.currentAvgDeltaCO2, agTypes.telemetry.siloGroup.currentMaxDeltaCO2];
        vm.telemetryLabel = $translate.instant('ag.co2.co2');
        vm.deltaTelemetryLabel = $translate.instant('ag.co2.delta-co2');
        vm.tabTelemetryLabel = $translate.instant('ag.co2.co2');
        vm.tabDeltaTelemetryLabel = $translate.instant('ag.co2.delta-co2');
        vm.helpPageAction = agUtils.createHelpActionConfig("agSiloGroup", "ag.docsPageSections.silo-group-co2-details");
    }

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.siloGroupId = null;
            if (vm.ctx.stateController) {
                vm.siloGroupId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSiloGroup();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloGroupId, prevSiloGroupId) {
                    if (newSiloGroupId && !angular.equals(newSiloGroupId, prevSiloGroupId)) {
                        vm.siloGroupId = newSiloGroupId;
                        vm.hideMoistureDetails = false;
                        vm.hideCO2Details = false;
                        loadSiloGroup();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.siloGroup ? (vm.siloGroup.label || vm.siloGroup.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function loadSiloGroup() {
        vm.siloGroup = null;
        vm.siloGroupData = null;
        reset();
        if (vm.siloGroupId) {
            vm.loading = true;
            siloGroupService.getSiloGroup(vm.siloGroupId).then(
                function success(siloGroup) {
                    vm.siloGroup = siloGroup;
                    loadTemperaturesThresholds();
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function loadTemperaturesThresholds() {
        siloGroupService.getSiloGroupSilos(vm.siloGroupId).then(
            (silos) => {
                vm.maxSiloGroupTelemetry = null;
                vm.maxSiloGroupDeltaTelemetry = null;
                if (vm.telemetryType === agTypes.telemetry.type.temperature) {
                    silos.forEach((silo) => {
                        if (angular.isDefined(silo.maxTemperature) && silo.maxTemperature != null) {
                            if (vm.maxSiloGroupTelemetry == null) {
                                vm.maxSiloGroupTelemetry = silo.maxTemperature;
                            } else {
                                vm.maxSiloGroupTelemetry = Math.min(vm.maxSiloGroupTelemetry, silo.maxTemperature);
                            }
                        }
                        if (angular.isDefined(silo.maxDeltaTemperature) && silo.maxDeltaTemperature != null) {
                            if (vm.maxSiloGroupDeltaTelemetry == null) {
                                vm.maxSiloGroupDeltaTelemetry = silo.maxDeltaTemperature;
                            } else {
                                vm.maxSiloGroupDeltaTelemetry = Math.min(vm.maxSiloGroupDeltaTelemetry, silo.maxDeltaTemperature);
                            }
                        }
                    });
                    vm.maxSiloGroupTelemetry = vm.maxSiloGroupTelemetry || 24;
                    vm.maxSiloGroupDeltaTelemetry = vm.maxSiloGroupDeltaTelemetry || 1;
                    vm.maxSiloGroupTelemetryThreshold = unitService.toUserTemperature(vm.maxSiloGroupTelemetry);
                    vm.maxSiloGroupDeltaTelemetryThreshold = unitService.toUserTemperature(vm.maxSiloGroupDeltaTelemetry, true);
                } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
                    var moistureFound = false;
                    silos.forEach((silo) => {
                        if (angular.isDefined(silo.maxMoisture) && silo.maxMoisture != null) {
                            if (vm.maxSiloGroupTelemetry == null) {
                                vm.maxSiloGroupTelemetry = silo.maxMoisture;
                            } else {
                                vm.maxSiloGroupTelemetry = Math.min(vm.maxSiloGroupTelemetry, silo.maxMoisture);
                            }
                        }
                        if (angular.isDefined(silo.maxDeltaMoisture) && silo.maxDeltaMoisture != null) {
                            if (vm.maxSiloGroupDeltaTelemetry == null) {
                                vm.maxSiloGroupDeltaTelemetry = silo.maxDeltaMoisture;
                            } else {
                                vm.maxSiloGroupDeltaTelemetry = Math.min(vm.maxSiloGroupDeltaTelemetry, silo.maxDeltaMoisture);
                            }
                        }
                        if (silo.hasMoistureCables) {
                            moistureFound = true;
                        }
                    });
                    vm.maxSiloGroupTelemetry = vm.maxSiloGroupTelemetry || 24;
                    vm.maxSiloGroupDeltaTelemetry = vm.maxSiloGroupDeltaTelemetry || 1;
                    vm.maxSiloGroupTelemetryThreshold = vm.maxSiloGroupTelemetry;
                    vm.maxSiloGroupDeltaTelemetryThreshold = vm.maxSiloGroupDeltaTelemetry;
                    if (!moistureFound) {
                        vm.hideMoistureDetails = true;
                    }
                } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
                    var co2Found = false;
                    silos.forEach((silo) => {
                        if (angular.isDefined(silo.maxCO2) && silo.maxCO2 != null) {
                            if (vm.maxSiloGroupTelemetry == null) {
                                vm.maxSiloGroupTelemetry = silo.maxCO2;
                            } else {
                                vm.maxSiloGroupTelemetry = Math.min(vm.maxSiloGroupTelemetry, silo.maxCO2);
                            }
                        }
                        if (angular.isDefined(silo.maxDeltaCO2) && silo.maxDeltaCO2 != null) {
                            if (vm.maxSiloGroupDeltaTelemetry == null) {
                                vm.maxSiloGroupDeltaTelemetry = silo.maxDeltaCO2;
                            } else {
                                vm.maxSiloGroupDeltaTelemetry = Math.min(vm.maxSiloGroupDeltaTelemetry, silo.maxDeltaCO2);
                            }
                        }
                        if (silo.hasCO2Cables) {
                            co2Found = true;
                        }
                    });
                    vm.maxSiloGroupTelemetry = vm.maxSiloGroupTelemetry || 24;
                    vm.maxSiloGroupDeltaTelemetry = vm.maxSiloGroupDeltaTelemetry || 1;
                    vm.maxSiloGroupTelemetryThreshold = vm.maxSiloGroupTelemetry;
                    vm.maxSiloGroupDeltaTelemetryThreshold = vm.maxSiloGroupDeltaTelemetry;
                    if (!co2Found) {
                        vm.hideCO2Details = true;
                    }
                }
                updateSubscriptions();
            },
            () => {
                vm.loading = false;
            }
        );
    }

    function reset() {
    }

    function updateSubscriptions() {
        vm.siloGroupTelemetryHistorySubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.asset,
            entityId: vm.siloGroupId.id,
            entityName: vm.siloGroup.name,
            timeseries: []
        }];

        vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.asset,
            entityId: vm.siloGroupId.id,
            entityName: vm.siloGroup.name,
            timeseries: []
        }];

        for (var i = 0; i < 3; i++) {
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries.push({units: vm.telemetryHistoryUnits, decimals: 1});
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries.push({
                units: vm.telemetryHistoryUnits,
                decimals: 1
            });
        }

        if (vm.telemetryType === agTypes.telemetry.type.temperature) {
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinTemperature;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-temperature');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.minColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgTemperature;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-temperature');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.avgColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxTemperature;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-temperature');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.maxColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinDeltaTemperature;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-delta-temperature');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.minColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgDeltaTemperature;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-delta-temperature');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.avgColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxDeltaTemperature;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-delta-temperature');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.maxColor;

            for (i = 0; i < 3; i++) {
                vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[i].postFuncBody = unitService.temperaturePostprocessingFuncBody();
                vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[i].postFuncBody = unitService.temperaturePostprocessingFuncBody(true);
            }

        } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinMoisture;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-moisture');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.hasAlarmsColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgMoisture;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-moisture');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.normalGreyColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxMoisture;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-moisture');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.minColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinDeltaMoisture;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-delta-moisture');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.hasAlarmsColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgDeltaMoisture;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-delta-moisture');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.normalGreyColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxDeltaMoisture;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-delta-moisture');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.minColor;
        } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinCO2;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-co2');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.hasAlarmsColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgCO2;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-co2');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.normalGreyColor;

            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxCO2;
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-co2');
            vm.siloGroupTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.minColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].name = agTypes.telemetry.silo.currentMinDeltaCO2;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].label = $translate.instant('ag.silo.min-delta-co2');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[0].color = agTypes.colors.hasAlarmsColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].name = agTypes.telemetry.silo.currentAvgDeltaCO2;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].label = $translate.instant('ag.silo.avg-delta-co2');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[1].color = agTypes.colors.normalGreyColor;

            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].name = agTypes.telemetry.silo.currentMaxDeltaCO2;
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].label = $translate.instant('ag.silo.max-delta-co2');
            vm.siloGroupDeltaTelemetryHistorySubscriptionsInfo[0].timeseries[2].color = agTypes.colors.minColor;
        }
        vm.loading = false;
    }

    function resolveIcon(isDelta) {
        if (vm.telemetryType === agTypes.telemetry.type.temperature) {
            return isDelta ? 'ag:delta_thermometer' : 'ag:thermometer';
        } else if (vm.telemetryType === agTypes.telemetry.type.moisture) {
            return isDelta ? 'ag:delta_moisture' : 'ag:moisture';
        } else if (vm.telemetryType === agTypes.telemetry.type.co2) {
            return isDelta ? 'ag:delta_co2_level' : 'ag:co2_level';
        } else {
            return '';
        }
    }
}
